
import { Badge } from "@mui/material";
import { ORANGE_YELLOW } from "utils/styles";

export default function SgcBadge({ children, badgeContent, color }) {

   return (
      <Badge
         overlap="rectangular"
         badgeContent={badgeContent}
         sx={{ 
            '& .MuiBadge-badge': {
               backgroundColor: color || ORANGE_YELLOW
            }  
         }}
      >
         {children}
      </Badge>
   )
}